import { Badge } from '@mantine/core';

import { AsCsReceiptStatus } from '../../../../../../shared/types/aiAgent/asCs';
import { getAsCsReceiptStatusLabel, isAsCsReceiptStatus } from '../../../../../../shared/utils/asCsStatus';

interface IStatusBadgeProps {
  status?: string | null;
}

const statusColors: Record<AsCsReceiptStatus, string> = {
  [AsCsReceiptStatus.REQUEST]: 'gray',
  [AsCsReceiptStatus.INPROGRESS]: 'blue',
  [AsCsReceiptStatus.COMPLETE]: 'green',
  [AsCsReceiptStatus.CANCEL]: 'red',
};

export default function StatusBadge({ status }: IStatusBadgeProps) {
  const color = status && isAsCsReceiptStatus(status) ? statusColors[status] : 'gray';

  return (
    <Badge color={color} variant="light" radius="sm">
      {getAsCsReceiptStatusLabel(status)}
    </Badge>
  );
}
